<div class="container" [style.left]="posX" [style.top]="posY">
  <div class="item" (click)="closeClick()">
    Закрыть меню
  </div>
  @for (it of items; track it) {
    <div class="item" (click)="itemClick(it)">
      {{it.name}}
    </div>
  }
</div>